import { render, staticRenderFns } from "./ReservationCountDown.vue?vue&type=template&id=b08f788e&"
import script from "./ReservationCountDown.vue?vue&type=script&lang=js&"
export * from "./ReservationCountDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports